import { render, staticRenderFns } from "./app-top-tabs.vue?vue&type=template&id=57a3f362&scoped=true&"
import script from "./app-top-tabs.vue?vue&type=script&lang=js&"
export * from "./app-top-tabs.vue?vue&type=script&lang=js&"
import style0 from "./app-top-tabs.vue?vue&type=style&index=0&id=57a3f362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a3f362",
  null
  
)

export default component.exports